module.exports = __webpack_public_path__ + "static/img/index-logo.82b1ad57.png";